import $ from "jquery";
import * as Common from "../../../../common/common";
import * as omnimap from "../../../../../api/omnimap/omnimapActions";

export default function standart() {}

export const FillTableCallBack = (result, page_number, columnList) => {
  var oTable = $("#example").dataTable();
  window.$catalog_management_units_Glist = [];
  if (page_number === 1) {
    oTable.fnClearTable();
  }
  if (page_number <= result.meta.total_pages) {
    if (result.data.length > 0) {
      $.each(result.data, function (index, data) {
        var circleType =
          data.content["algemeen-actief"] === true
            ? '<div class="green-circle rounded-circle"><span class="tooltiptext">Actief</span></div>'
            : '<div class="red-circle rounded-circle"><span class="tooltiptext">Inactief</span></div>';
        var algemeenNaam =
          '<span class="text-dark font-weight-bold">' +
          data.content["algemeen-naam"] +
          "</span>";
        var algemeenCode = data.content["algemeen-code"];
        if (typeof algemeenCode === "undefined") {
          algemeenCode = "";
        } else algemeenCode = '<a href="javascript:void(0)">' + data.content["algemeen-code"] + "</a>";
        var checkbox =
          '<label class="ct-checkbox"><input type="checkbox"><span class="checkmark"></span></label>';

        var horizon = "";
        var startDate = "";
        var endDate = "";
        if (typeof data.content["algemeen-horizon"] !== "undefined") {
          startDate = Common.FormatDate(
            data.content["algemeen-horizon"][0],
            "date"
          );
          endDate = Common.FormatDate(
            data.content["algemeen-horizon"][1],
            "date"
          );
          horizon = startDate + " " + endDate;
        }

        let aantalbijlagen = data.content["algemeen-aantalbijlagen"];
        if (typeof aantalbijlagen === "undefined") {
          aantalbijlagen = "";
        }


        var model = {
          identification: data.identification,
          isActive: data.content["algemeen-actief"],
          algemeenNaam: data.content["algemeen-naam"],
          algemeenCode: data.content["algemeen-code"],
          aantalbijlagen: aantalbijlagen,
          horizon: horizon,
          startDate: startDate,
          endDate: endDate,
        };

        var test = {
          checkbox: checkbox,
          active: circleType,
          "Naam Beheereenheid": algemeenNaam,
          "Code beheereenheid": algemeenCode,
          paperclip: aantalbijlagen,
          Horizon: horizon,
        };

        let _columnList = [];
        if (columnList && columnList.column_list){
          for (let column in columnList.column_list) {
            for (let key in test) {
              if (
                  columnList.column_list[column].toLowerCase() === key.toLowerCase()
              ) {
                _columnList.push(test[key]);
              }
            }
          }
        }

        // that.Glist.push(model);
        window.$catalog_management_units_Glist.push(model);
        var addId = oTable.fnAddData(
            [
              ..._columnList,
            ],
            false
        );

        if(addId.length > 0) {
          var theNode = $("#example").dataTable().fnSettings().aoData[
              addId[0]
              ].nTr;
          theNode.setAttribute("rowId", data["identification"]);
        }
      });
      oTable.fnDraw();
    } else {
      $("tbody").html();
      oTable.fnClearTable();
    }
  }
  $("#total-rows").html(result.meta.total_found);
  window.$catalog_management_units_table_total_row_count =
    result.meta.total_found;
  $("#cover-spin").hide(0);
  window.$catalog_management_units_treeChangeStatus = true;
  window.$catalog_management_units_scroll_change = true;
};

export const FillFilterColumnsCallBack = (data, result) => {
  if (data.id === "algemeen-code") {
    $.each(result.data.values, function (index, data) {
      window.$catalog_management_units_algemeenCode.push(data);
    });
  }
};

export const SearchFilterColumnsCallBack = (searchId, result) => {
  if (searchId === "algemeen-code") {
    window.$catalog_management_units_algemeenCode.length = 0;
    $.each(result.data.values, function (index, data) {
      window.$catalog_management_units_algemeenCode.push(data);
    });
  }
  if (searchId === "algemeen-naam") {
    window.$catalog_management_units_algemeenNaam.length = 0;
    $.each(result.data.values, function (index, data) {
      window.$catalog_management_units_algemeenNaam.push(data);
    });
  }
};

export const beheereenheidSavedCallBack = (token) => {
  Common.sleep(1000).then(() => {
    var model = {
      action: "ADD",
      contextRol: "Beheereenheid zit in folder",
      folder: document.getElementById("tree-parent-id").value,
    };
    Common.StartActivity(
      model,
      [window.$catalog_management_units_newInsertId],
      "708371ee-e3f6-4de7-87f8-dfe94b86f9b1",
      beheereenheidSavedNext(token),
      token
    );
  });
};
function beheereenheidSavedNext(token) {
  Common.sleep(5000).then(() => {
    $("#beheereenheid_toevoegen_modal").modal("hide");
    window.$catalog_management_units_refresh();
    /*omnimap
      .FillTableAction(
        window.$catalog_management_units_lastUsedTableFilter,
        1,
        token
      )
      .then((result) => {
        FillTableCallBack(result, 1);
      });*/
  });
}

export const BeheereenheidEditCallBack = (token) => {
  Common.sleep(1500).then(() => {
    window.$catalog_management_units_refresh();
    /*omnimap
      .FillTableAction(
        window.$catalog_management_units_lastUsedTableFilter,
        1,
        token
      )
      .then((result) => {
        FillTableCallBack(result, 1);
      });*/
  });
};

export const RowsDeletedCallBack = (token) => {
  Common.sleep(500).then(() => {
    $("#management-units-mappen_beheren_delete_modal").modal("hide");
    window.$catalog_management_units_refresh();
    /*omnimap
      .FillTableAction(
        window.$catalog_management_units_lastUsedTableFilter,
        1,
        token
      )
      .then((result) => {
        FillTableCallBack(result, 1);
      });*/
  });
};

export const GetActionsOfRowCallback = async (result) => {
  var actionsOfSelection = [];
  var actionsOfDisabled = [];
  var BreakException = {};

  $.each(result.data.stages, function (index, stage) {
    if (stage.definition.type === "activity" && stage.start_allowed === true) {
      actionsOfSelection.push(stage.definition.identification);
    } else {
      actionsOfDisabled.push(stage.definition);
    }
  });

  $("#myPopup").html("");
  $.each(window.$catalog_management_units_actions, function (index, action) {
    if ($.inArray(action["id"], actionsOfSelection) !== -1) {
      var anchor = $("<a></a>")
        .attr({ href: "javascript:void(0)", id: action["id"] })
        .addClass(action["class"] + " catalog-action")
        .html(action["text"]);
      $("#myPopup").append(anchor);
    }
  });

  //** aktif olmayan actionlar burada listeleniyor. */
  $.each(actionsOfDisabled, function (index, action) {
    var anchor = $("<a disabled></a>")
      .attr({ href: "javascript:void(0)", id: action["identification"] })
      .addClass("disabled" + " catalog-action")
      .html(action["name"]);
    $("#myPopup").append(anchor);
  });
  var isDelete = true;
  if (result.data.stages.length > 0) {
    let arr = window.$catalog_management_units_selectedIds;
    for (let i = 0; i < arr.length; i++) {
      let getRowOfDetail = await omnimap.GetRowOfDetailAction(
        arr[i],
        window.$catalog_management_units_token
      );

      if (
        getRowOfDetail.data.delete_allowed &&
        getRowOfDetail.data.delete_allowed !== undefined
      ) {
        // var verwijderen = $("<a></a>")
        //   .attr({ href: "javascript:void(0)", id: "verwijderen" })
        //   .addClass("trash-bin beheereenheid")
        //   .html("Verwijderen");
        // $("#myPopup").append(verwijderen);
        // break;
        isDelete = true;
      } else {
        // var verwijderen = $('<a style="cursor: no-drop;color: #ccc;"></a>')
        //   .attr({ href: "javascript:void(0)", id: "" })
        //   .addClass("trash-bin beheereenheid")
        //   .html("Verwijderen");
        // verwijderen.append(
        //   `<span class="tooltiptext" style="top: 165px;">kan niet worden verwijderd<br>omdat het in beheerobjects</span>`
        // );
        // $("#myPopup").append(verwijderen);
        // break;

        isDelete = false;
        break;
      }
    }
    if (isDelete) {
      var verwijderen = $("<a></a>")
        .attr({ href: "javascript:void(0)", id: "verwijderen" })
        .addClass("trash-bin beheereenheid")
        .html("Verwijderen");
      $("#myPopup").append(verwijderen);
    } else {
      var verwijderen = $('<a style="cursor: no-drop;color: #ccc;"></a>')
        .attr({ href: "javascript:void(0)", id: "" })
        .addClass("trash-bin beheereenheid")
        .html("Verwijderen");
      verwijderen.append(
        `<span class="tooltiptext" style="top: 165px;">kan niet worden verwijderd<br>omdat het in beheerobjects</span>`
      );
      $("#myPopup").append(verwijderen);
    }
  } else {
    var beheereenheidToevoegen = $("<a></a>")
      .attr({ href: "javascript:void(0)", id: "beheereenheid_toevoegen" })
      .addClass("maatregelen beheereenheid")
      .html("Beheereenheid toevoegen");
    $("#myPopup").append(beheereenheidToevoegen);

    var mapAanmaken = $("<a></a>")
      .attr({ href: "javascript:void(0)", id: "map_aanmaken" })
      .addClass("folder-popup beheereenheid")
      .html("Map aanmaken");
    $("#myPopup").append(mapAanmaken);
  }
  var popup = document.getElementById("myPopup");
  popup.classList.toggle("show");
};

export function TableColumnChangeHandler(
  settings,
  data,
  identification,
  columnOrderReference,
  COLUMN_ORDER_CATALOG_MANAGEMENT_UNIT
) {
  var names = settings.aoColumns;
  if (names[0]) {
  }
  var test_list = [];
  names.forEach((element, index) => {
    test_list.push(element.sTitle);
  });

  var checkIndex = test_list.findIndex((x) => x.includes("checkAll"));
  test_list[checkIndex] = "checkbox";
  var statusIndex = test_list.findIndex((x) => x.includes("snowflake"));
  test_list[statusIndex] = "active";
  let paperIndex = test_list.findIndex((x) => x.includes("bijlage"));
  test_list[paperIndex] = "paperclip";
  var model = {
    identification: identification,
    code: COLUMN_ORDER_CATALOG_MANAGEMENT_UNIT,
    client_identification: COLUMN_ORDER_CATALOG_MANAGEMENT_UNIT,
    reference: columnOrderReference,
    data: {
      table_sorting: [
        {
          name: "catalog>management-units",
          column_list: [],
        },
      ],
    },
  };
  var asd = (model.data.table_sorting.find(
    (x) => x.name === "catalog>management-units"
  ).column_list = test_list);
  omnimap.GetFreeFormatAction(identification, "PUT", model);

  return model.data.table_sorting[0];
}
